import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../svgIcon/SvgIcon';

export function LogoLounge(props) {
    return (
        <SvgIcon {...props}>
            <path
                fill="#EDA820"
                d="M166.713,23.948c-0.059-0.327-0.292-0.477-0.484-0.477c-0.018,0-0.035,0.002-0.026,0.003
            c0,0-0.244-0.012-0.485-0.012h-0.003c-0.694-0.022-1.27-0.123-1.28-1.139V1.07c-0.002-0.354-0.215-0.718-0.626-0.728l-0.12,0.001
            l-1.898,0.486c-0.323,0.033-0.66,0.263-0.646,0.69v20.873c0.004,2.473,1.33,3.836,3.736,3.84h0.002h0.001
            c0.974-0.019,1.694-0.211,1.977-0.527c0.1-0.113,0.146-0.242,0.134-0.37c-0.007-0.105-0.007-0.105-0.273-1.357L166.713,23.948z"
            />
            <path
                fill="#EDA820"
                d="M177.415,6.728c-7.708,0.012-8.361,5.076-8.368,9.822c0.007,4.729,0.66,9.777,8.368,9.788h0.002
            c7.701-0.011,8.357-5.045,8.369-9.788C185.777,11.586,185.125,6.739,177.415,6.728z M177.416,23.566
            c-4.676-0.021-4.91-2.421-4.942-7.016c0.032-4.619,0.267-7.031,4.941-7.052c4.677,0.021,4.911,2.433,4.942,7.049
            C182.326,21.146,182.092,23.545,177.416,23.566z"
            />
            <path
                fill="#EDA820"
                d="M204.188,6.989h-0.139l-2.251,0.527c-0.316,0.035-0.491,0.175-0.491,0.527l0.034,11.353
            c0,2.46-0.421,4.499-4.604,4.499c-3.515,0-4.605-1.372-4.605-4.428V7.481c0-0.246-0.104-0.492-0.386-0.492h-0.105l-2.285,0.492
            c-0.281,0.07-0.491,0.21-0.491,0.527v11.177c0,4.71,1.792,7.172,7.873,7.172c6.994,0,7.839-3.517,7.839-7.207V7.481
            C204.575,7.2,204.469,6.989,204.188,6.989z"
            />
            <path
                fill="#EDA820"
                d="M243.085,10.575c0-1.302-0.105-2.32-2.284-2.848c-1.266-0.316-3.129-0.738-5.625-0.738
            c-6.325,0-8.364,2.777-8.364,9.736c0,6.327,1.476,9.632,8.26,9.632c2.438,0,3.675-0.305,4.768-0.578v0.136v0.001v2.489
            c0,0.067,0,0.222,0,0.222c-0.098,2.144-1.092,3.814-4.881,3.814c-2.801,0-4.447-0.787-5.233-2.624
            c-0.115-0.16-0.31-0.216-0.536-0.126l-1.688,0.674c-0.272,0.107-0.343,0.326-0.247,0.57l-0.006,0.007
            c0.892,2.648,3.201,4.058,7.711,4.058c6.996,0,8.13-3.614,8.13-7.304v-0.592h-0.003V10.575z M230.186,16.69
            c0-6.046,1.582-7.205,5.237-7.205c2.354,0,4.428,0.562,4.428,0.562v13.215c0,0-1.969,0.633-4.393,0.633
            C232.048,23.896,230.186,23.192,230.186,16.69z"
            />
            <path
                fill="#EDA820"
                d="M261.446,9.977c-1.195-1.898-3.339-2.987-6.993-2.987c-6.926,0-8.296,3.62-8.296,9.701
            c0,6.572,2.215,9.667,9.104,9.667c2.425,0,4.744-0.492,6.115-1.056c0.247-0.069,0.387-0.211,0.387-0.421
            c0-0.035,0-0.106-0.034-0.141l-0.388-1.442c-0.104-0.245-0.21-0.352-0.386-0.352c-0.07,0-0.14,0-0.212,0.036
            c-1.512,0.422-2.916,0.878-5.096,0.878c-2.32,0-3.937-0.387-4.922-1.512c-0.809-0.878-1.193-1.933-1.193-3.797h12.652
            c0.247,0,0.492-0.28,0.492-0.526v-1.722C262.677,13.772,262.432,11.594,261.446,9.977z M249.496,16.093
            c0.036-1.266,0.07-2.565,0.386-3.762c0.563-2.143,1.829-2.846,4.534-2.846c2.636,0,3.938,0.667,4.499,2.846
            c0.316,1.231,0.388,2.461,0.422,3.727L249.496,16.093z"
            />
            <path
                fill="#EDA820"
                d="M217.518,6.721c-2.286,0.002-5.748,0.531-7.557,1.156c-1.89,0.611-2.014,1.529-1.988,2.857v14.349
            c0,0.454,0.343,0.797,0.797,0.798h1.729c0.441-0.001,0.762-0.336,0.763-0.798V10.394c0.88-0.24,3.549-0.901,6.185-0.901
            c2.33,0.032,2.977,0.634,3.008,2.799v12.792c0.001,0.454,0.344,0.797,0.798,0.798h1.694c0.453-0.001,0.796-0.344,0.797-0.798
            V11.979C223.736,8.299,221.876,6.727,217.518,6.721z"
            />
            <path
                fill={props.dark ? '353535' : '#FFFFFF'}
                d="M69.974,7.663c-1.14-0.627-2.834-0.933-5.182-0.934c-3.21,0.002-6.19,0.668-7.318,1.088
            c-0.256,0.082-0.527,0.302-0.532,0.678l0.001,0.084l0.316,1.596l0.008,0.03c0.099,0.325,0.369,0.471,0.615,0.471h0.002
            c0.079-0.003,0.142-0.019,0.198-0.033l0.534-0.125c1.399-0.35,3.513-0.879,5.874-0.879c1.432,0,2.394,0.124,3.039,0.397
            c1.048,0.396,1.054,1.073,1.065,2.193v1.676c-0.121-0.002-0.323-0.004-0.635-0.004c-1.156,0-3.43,0.054-5.666,0.412
            c-3.411,0.523-6.234,1.34-6.217,6.041c0.002,5.968,5.537,5.979,8.196,5.984l0,0c1.806,0,3.472-0.267,4.561-0.492
            c2.482-0.576,3.116-1.364,3.083-3.832v-9.923C71.921,10.578,71.925,8.694,69.974,7.663 M68.611,22.99
            c-1.322,0.43-2.768,0.646-4.3,0.646v0.14l-0.002-0.14c-2.447-0.019-4.837-0.299-4.84-3.419c0.016-2.483,1.341-2.778,3.018-3.152
            l0.116-0.026c1.491-0.318,5.235-0.379,6.008-0.388V22.99z M99.586,12.092v9.923c0.033,2.468-0.601,3.256-3.084,3.832
            c-1.088,0.226-2.754,0.492-4.56,0.492l0,0c-2.66-0.005-8.195-0.017-8.196-5.984c-0.019-4.701,2.806-5.518,6.217-6.041
            c2.235-0.358,4.509-0.412,5.665-0.412c0.312,0,0.515,0.002,0.635,0.004v-1.676c-0.011-1.12-0.018-1.798-1.064-2.193
            c-0.646-0.273-1.608-0.397-3.04-0.397c-2.36,0-4.475,0.529-5.873,0.879l-0.534,0.125c-0.058,0.015-0.119,0.03-0.199,0.033h-0.001
            c-0.246,0-0.518-0.146-0.616-0.471l-0.008-0.03L84.61,8.579V8.495c0.004-0.376,0.276-0.596,0.531-0.678
            c1.128-0.42,4.108-1.086,7.319-1.088c2.347,0.001,4.041,0.307,5.182,0.934C99.594,8.694,99.589,10.578,99.586,12.092
            M96.279,16.651c-0.772,0.009-4.517,0.069-6.008,0.388l-0.116,0.026c-1.677,0.374-3.001,0.669-3.017,3.152
            c0.003,3.12,2.393,3.4,4.839,3.419l0.002,0.14v-0.14c1.532,0,2.978-0.217,4.3-0.646V16.651z M149.705,6.729
            c-7.708,0.011-8.361,5.076-8.369,9.822c0.008,4.729,0.661,9.776,8.369,9.787h0.001c7.702-0.011,8.358-5.044,8.369-9.788
            C158.067,11.587,157.414,6.74,149.705,6.729 M149.706,23.567c-4.676-0.021-4.911-2.42-4.942-7.016
            c0.031-4.619,0.266-7.031,4.941-7.052c4.677,0.021,4.911,2.433,4.942,7.05C154.616,21.147,154.381,23.547,149.706,23.567
            M135.872,25.641l-0.201,0.051c-1.078,0.273-2.555,0.647-5.144,0.647l0,0h-0.005c-7.135-0.011-8.534-3.609-8.542-9.822
            c0.009-7.125,2.267-9.777,8.334-9.787c2.14,0,3.614,0.277,4.672,0.532l-0.006-5.738c-0.009-0.252,0.105-0.582,0.7-0.695
            l1.895-0.483h0.104c0.436,0.011,0.59,0.398,0.591,0.728v21.564C138.299,23.998,138.139,25.167,135.872,25.641 M134.981,10.024
            c-0.633-0.161-2.398-0.559-4.387-0.559c-3.652,0.034-5.185,1.025-5.222,7.086c0.042,6.656,2.023,7.016,5.254,7.05l0.003,0.14
            v-0.14c2.01,0,3.735-0.419,4.351-0.588L134.981,10.024z M117.954,25.89h-1.694c-0.454-0.001-0.796-0.344-0.798-0.798V12.299
            c-0.03-2.164-0.677-2.766-3.008-2.799c-2.636,0-5.305,0.662-6.185,0.901v14.69c-0.001,0.462-0.321,0.797-0.763,0.798h-1.729
            c-0.454-0.001-0.797-0.344-0.797-0.798V10.743c-0.025-1.328,0.099-2.247,1.988-2.857c1.81-0.625,5.271-1.154,7.558-1.156
            c4.357,0.006,6.219,1.578,6.225,5.258v13.104C118.75,25.546,118.408,25.889,117.954,25.89 M79.571,26.235L79.571,26.235
            c0.975-0.02,1.695-0.212,1.978-0.528c0.1-0.112,0.146-0.242,0.134-0.37c-0.007-0.105-0.007-0.105-0.273-1.357l-0.007-0.029
            c-0.058-0.327-0.291-0.477-0.483-0.477c-0.019,0-0.036,0.001-0.026,0.003c0,0-0.244-0.013-0.486-0.013h-0.002
            c-0.694-0.021-1.27-0.123-1.281-1.139V1.072c-0.001-0.354-0.215-0.718-0.625-0.728l-0.121,0.001l-1.898,0.486
            c-0.323,0.033-0.659,0.263-0.646,0.69v20.872c0.004,2.473,1.33,3.836,3.736,3.841H79.571z M52.765,25.89H39.166
            c-0.454-0.001-0.796-0.344-0.797-0.798v-1.66c-0.01-0.406,0.12-0.588,0.371-0.898L49.564,9.95H38.959
            c-0.454-0.001-0.797-0.344-0.798-0.798V7.977c0.001-0.453,0.344-0.796,0.798-0.797h13.736c0.454,0.001,0.797,0.344,0.798,0.797
            v1.694c0.006,0.306-0.1,0.566-0.344,0.839L42.298,23.118h10.467c0.453,0.001,0.796,0.344,0.798,0.798v1.176
            C53.561,25.546,53.218,25.889,52.765,25.89"
            />
            <path
                fill="#EDA820"
                d="M28.781,12.219c-2.232-2.738-5.354-5.396-9.441-7.795l-0.015-0.009C15.204,2.074,11.342,0.7,7.854,0.136
            c-2.177-0.352-3.218,0.058-3.69,0.331C3.689,0.74,2.814,1.437,2.031,3.498C0.775,6.801,0.033,10.833,0,15.571v0.018
            c0.033,4.739,0.775,8.772,2.031,12.075c0.783,2.062,1.658,2.758,2.132,3.03c0.473,0.273,1.514,0.684,3.69,0.331
            c3.488-0.564,7.351-1.938,11.472-4.278l0.015-0.01c4.088-2.397,7.209-5.057,9.441-7.796c1.394-1.709,1.56-2.814,1.56-3.361
            C30.341,15.034,30.175,13.929,28.781,12.219z"
            />
        </SvgIcon>
    );
}

LogoLounge.defaultProps = {
    viewBox: '0 0 263 35',
};

LogoLounge.propTypes = {
    dark: PropTypes.bool,
};

export default LogoLounge;
